import { useFormikContext } from 'formik';
import {useEffect} from "react";

const FormErrorResetEffect = ({ resetError }) => {
    const { values } = useFormikContext();

    useEffect(() => {
        resetError();
    }, [values.email, values.password]);

    return null;
};
export default FormErrorResetEffect;
